import React, { useContext } from 'react';
import { NavigationContext } from '../context/NavigationContext';

export const withNavigationContext = (BaseComponent) => {
  return (props) => {
    const navigationContext = useContext(NavigationContext);
    return (
      <BaseComponent
        navigationContext={navigationContext}
        {...props}
      />
    );
  };
};
